import { render, staticRenderFns } from "./MatrAddProd.vue?vue&type=template&id=5fb95078&scoped=true&"
import script from "./MatrAddProd.vue?vue&type=script&lang=js&"
export * from "./MatrAddProd.vue?vue&type=script&lang=js&"
import style0 from "./MatrAddProd.vue?vue&type=style&index=0&id=5fb95078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb95078",
  null
  
)

export default component.exports